import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableHead from '@material-ui/core/TableHead';
import enhancedTableColsProps from './EnhancedTable.cols.props';

const EnhancedTableHead = (props) => {
    const {
        onSelectAllClick,
        onRequestSort,
        order,
        orderBy,
        numSelected,
        rowCount,
        cols,
        selectableRows,
    } = props;

    const createSortHandler = property => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {selectableRows
                && (
                    <TableCell padding="checkbox">
                        <Checkbox
                            color="primary"
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell>
                )
                }
                {cols.map(
                    col => (
                        <TableCell
                            key={col.id}
                            align={col.numeric ? 'right' : 'left'}
                            padding={col.disablePadding ? 'none' : 'default'}
                            sortDirection={orderBy === col.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === col.id}
                                direction={order}
                                onClick={!col.disableSorting ? createSortHandler(col.id) : null}
                            >
                                {col.label}
                            </TableSortLabel>
                        </TableCell>
                    ),
                    this,
                )}
            </TableRow>
        </TableHead>
    );
};

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    cols: enhancedTableColsProps.isRequired,
    selectableRows: PropTypes.bool.isRequired,
};

export default EnhancedTableHead;
